<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="businessUnitHeader" class="page-name color-71aa3f">
                        Create Business Unit
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backshowtask">Back</button>
                </div>
                <div class="admin-page-content">
                    <form id="businessunit">
                        <div class="forms-container">
                            <div class="row no-margin">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                    <div class="alert alert-success" id="alertSuccess">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <span>Business Unit Added Successfully</span>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <span id="errorMsg" class="error"></span>
                                    </div>
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Business Unit Owner</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <v-select id="collector" v-model="assigned_to_business_id" @change="userChangedValue" name="assigned_to_business_id" label="text" :filterable="false" :options="businessArr" @search="onSearchUser" v-validate="'required'"
                                                  placeholder="Select Business Unit">
                                            <template slot="no-options">
                                                Search Business Units...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <span v-show="errors.has('assigned_to_business_id')" class="help is-danger" v-if="errors.has('assigned_to_business_id')"><font color="red">Business Unit is Required</font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Name</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" id="name" name="name" class="form-control"
                                               placeholder="Enter Name" v-model="name"
                                               v-validate="'required'">
                                        <div class="requiredstar">*</div>
                                        <span v-show="errors.has('name')" class="help is-danger" v-if="errors.has('name')"><font color="red">Name is Required</font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Phone No.</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" id="phone" name="phone" class="form-control"
                                               placeholder="Enter Phone No." v-model="phone"
                                               v-validate="'required'">
                                        <div class="requiredstar">*</div>
                                        <span class="help is-danger" v-if="errors.has('phone')" v-show="phone == ''"><font color="red">Phone No. is Required<br></font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Website</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" id="website" name="website" class="form-control"
                                               placeholder="Enter Website" v-model="website"
                                               >
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Email</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" id="email" name="email" class="form-control"
                                               placeholder="Enter Email" v-model="email"
                                               v-validate="'required|email'">
                                        <div class="requiredstar">*</div>
                                        <span class="help is-danger" v-if="errors.first('email')" v-show="email != ''"><font color="red">Email Must Be A Valid Email</font></span>
                                        <span class="help is-danger" v-if="errors.has('email')" v-show="email == ''"><font color="red">Email is Required</font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Fax</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" id="fax" name="fax" class="form-control"
                                               placeholder="Enter Fax" v-model="fax" >
                                    </div>    
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="col-1point5 paddingleft0">
                                        <div class="form-label"><strong>Description</strong></div>
                                    </div>
                                    <div class="col-10point5 paddingleft0">
                                        <textarea rows="10" type="text" id="description" name="description" class="form-control no-resize"
                                                  placeholder="Enter Description" v-model="description"
                                                  ></textarea>
                                    </div>    
                                </div>
                                <div class="col-12">
                                    <div class="col-12 paddingleft0">
                                        <input id="addTaskBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddBusinessUnits()">
                                        <input id="addAndContinueTaskBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="AddBusinessUnits(flag='Save and Continue')">
                                        <input id="CancelTask" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backshowtask">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!--<div class="container-fluid">
                <div class="row clearfix">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card form-header-task">
                            <div class="body full-task-main">
                                <form id="">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="button-demo">

                                        </div>
                                    </div>
                                    <div class="row clearfix"></div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import index from "../../router";
    import Vue from 'vue';
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from 'vee-validate';
    import EventBus from '../event-bus';
    Vue.use(VeeValidate);
    import SessioMixin from '../../mixins/sessionmixin';

    var segments = '';
    export default {
        name: "AddBusinessUnits",
        components: {
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                permissions: [],
                cantAccessPage: true,
                name: '',
                phone: '',
                website: '',
                email: '',
                fax: '',
                description: '',
                businessArr: [],
                assigned_to_business_id: '',
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menubusinessunits").addClass('active');
            var self = this;
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            var path = window.location.pathname;
            segments = path.split("/");
            var self = this;
            if (segments[3]) {
                self.showLoader();
                self.loadBusinessUnits()
                // $("#addAndContinueTaskBtn").prop('disabled',true);
                $('#addAndContinueTaskBtn').hide();
                $("#addTaskBtn").val('Update');
                $("#businessUnitHeader").text('Edit Business Unit');
            }
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_business_unit') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            changedValue: function (value) {
                //console.log(value);
            },

            onSearch(search, loading) {
                if (search.length > 1) {
                    loading(true);
                    this.loadCustomer(loading, search, this);
                }

            },
            /*onSearchUser(search, loading) {
             if (search.length > 1) {
             loading(true);
             this.loadUser(loading, search, this);
             }
             
             },*/

            userChangedValue: function (value) {
                //console.log(value);
            },
            onSearchUser(search, loading) {
                if (search.length > 1) {
                    loading(true);
                    this.loadBusinessUnit(loading, search, this);
                }
            },
            loadBusinessUnit(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/getbusinessunits",
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        loading(false);

                        self.businessArr = data;
                        //console.log(self.businessArr);
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })

            },

            backshowtask() {
                var self = this;
                self.$router.push('/listbusinessunits');

            },

            AddBusinessUnits(flag) {
                this.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var self = this;
                        //console.log(segments[3]);
                        if (segments[3]) {
                            //console.log(segments[3]);
                            $("#addTaskBtn").val('Updating ...');
                            $("#addTaskBtn").prop('disabled', true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelTask").prop('disabled', true);

                        } else {
                            if (flag == 'Save and Continue') {
                                $("#addAndContinueTaskBtn").val('Saving ...');
                                $("#addAndContinueTaskBtn").prop('disabled', true);
                                $("#addTaskBtn").prop('disabled', true);
                                $("#CancelTask").prop('disabled', true);
                            } else {
                                $("#addTaskBtn").val('Saving ...');
                                $("#addTaskBtn").prop('disabled', true);
                                $("#addAndContinueTaskBtn").prop('disabled', true);
                                $("#CancelTask").prop('disabled', true);
                            }
                        }

                        var fields = $('#businessunit').serializeArray();
                        fields.push({name: 'assigned_to_business_id', value: self.assigned_to_business_id.value});
                        this.$validator.validateAll();
                        this.$validator.errors.clear();

                        if (segments[3]) {
                            fields.push({name: 'id', value: segments[3]});
                        } else {

                            fields.push({name: 'id', value: 0});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/createbusinessunit",
                            type: "POST",
                            data: fields,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                if (segments[3]) {
                                    //console.log(segments[3]);
                                    $("#addTaskBtn").val('Update');
                                    $("#addTaskBtn").prop('disabled', false);
                                    // $("#addAndContinueCaseBtn").prop('disabled',true);
                                    $("#CancelTask").prop('disabled', false);

                                } else {
                                    if (flag == 'Save and Continue') {
                                        $("#addAndContinueTaskBtn").val('Save and Continue');
                                        $("#addAndContinueTaskBtn").prop('disabled', false);
                                        $("#addTaskBtn").prop('disabled', false);
                                        $("#CancelTask").prop('disabled', false);
                                    } else {
                                        $("#addTaskBtn").val('Save');
                                        $("#addTaskBtn").prop('disabled', false);
                                        $("#addAndContinueTaskBtn").prop('disabled', false);
                                        $("#CancelTask").prop('disabled', false);

                                    }
                                }
                                if (data.status == "success") {
                                    // self.$router.push('/task/list');
                                    if (flag == 'Save and Continue') {
                                        $('html, body').animate({scrollTop: '0px'}, 500);
                                        $(".alert-success").parent().removeClass('hide');
                                        $(".alert-success").parent().addClass('show');
                                        self.name = '';
                                        self.phone = '';
                                        self.website = '';
                                        self.email = '';
                                        self.fax = '';
                                        self.assigned_to_business_id = '';
                                        self.description = '';
                                        self.businessArr = [];
                                        setTimeout(function () {
                                            $('.alert-success').parent().removeClass('show');
                                            $('.alert-success').parent().addClass('hide');
                                        }, 5000);

                                    } else {
                                        self.$router.push('/listbusinessunits');
                                    }

                                } else {
                                    // $(".alert-danger").parent().removeClass('hide');
                                    // $(".alert-danger").parent().addClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);
                                    }
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[3]) {
                                    $("#addTaskBtn").val('Update');
                                    $("#addTaskBtn").prop('disabled', false);
                                    // $("#addAndContinueCaseBtn").prop('disabled',true);
                                    $("#CancelTask").prop('disabled', false);
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-danger").parent().removeClass('hide');
                                    $(".alert-danger").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.alert-danger').parent().removeClass('show');
                                        $('.alert-danger').parent().addClass('hide');
                                    }, 5000);
                                } else {

                                    if (flag == 'Save and Continue') {
                                        $("#addAndContinueTaskBtn").prop('disabled', false);
                                        $("#addAndContinueTaskBtn").val('Save and Continue');
                                        $("#addTaskBtn").prop('disabled', false);
                                        $("#CancelTask").prop('disabled', false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        self.name = '';
                                        self.phone = '';
                                        self.website = '';
                                        self.email = '';
                                        self.fax = '';
                                        self.assigned_to_business_id = '';
                                        self.description = '';
                                        self.businessArr = [];
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);

                                    } else {
                                        $("#addTaskBtn").val('Save');
                                        $("#addTaskBtn").prop('disabled', false);
                                        $("#addAndContinueTaskBtn").prop('disabled', true);
                                        $("#CancelTask").prop('disabled', false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);

                                    }

                                    if (jqXHR.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (jqXHR.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem('user_obj');
                                            localStorage.removeItem('api_token');
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }

                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);
                                    }
                                }
                            }
                        });
                    }
                });
            },

            loadBusinessUnits() {

                var path = window.location.pathname;
                segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/businessunits/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    // dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        self.name = data[0].name;
                        self.phone = data[0].phone;
                        self.website = data[0].website;
                        self.email = data[0].email;
                        self.fax = data[0].fax;
                        if (data[0].business_unit_owner_id != null) {
                            self.assigned_to_business_id = {value: data[0].business_unit_owner_id, text: data[0].owner_name};
                        }
                        self.description = data[0].description;
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/businessUnit/CreateBusinessUnit.vue